export default __webpack_public_path__ + "static/media/22.d102fc09.png";